import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE = 'https//api.monkeybox.ai/api/plandetails';

export const fetchPlans = createAsyncThunk('plans/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const res = await axios.get(API_BASE);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const createPlan = createAsyncThunk('plans/create', async (payload, { rejectWithValue }) => {
  try {
    const res = await axios.post(API_BASE, payload);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const updatePlan = createAsyncThunk('plans/update', async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await axios.patch(`${API_BASE}/${id}`, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

const planSlice = createSlice({
  name: 'plans',
  initialState: {
    plans: [],
    isLoading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetPlanState: (state) => {
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlans.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.isLoading = false;
        state.plans = action.payload;
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createPlan.fulfilled, (state, action) => {
        state.plans.push(action.payload);
        state.success = true;
      })
      .addCase(updatePlan.fulfilled, (state, action) => {
        const index = state.plans.findIndex(p => p.id === action.payload.id);
        if (index !== -1) state.plans[index] = action.payload;
        state.success = true;
      });
  },
});

export const { resetPlanState } = planSlice.actions;
export default planSlice.reducer;
